import React from 'react';

export const EmergencyBanner: React.FC = () => {
  return (
    <div
      role="alert"
      aria-live="polite"
      className="w-full bg-base-200 text-base-content/80 text-xs md:text-sm py-1.5 px-4 flex items-center justify-center gap-2 border-b border-base-300 font-medium sticky top-0 z-50 shadow-xs"
    >
      <span className="text-base shrink-0" aria-hidden="true">⚠️</span>
      <span>
        <strong>Emergency Notice:</strong> In case of a medical emergency, call emergency services immediately (<strong>911</strong> / <strong>112</strong>) or go to the nearest hospital.
      </span>
    </div>
  );
};

export default EmergencyBanner;
